import React, { useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import FormTextField from "components/form/form-textfield";
import FormCheckbox from "components/form/form-checkbox";
import { injectIntl, FormattedMessage } from "react-intl";
import DataGrid, { DataGridItem } from "components/data-grid";
import Card from "components/card";
import withStyles from "components/with-styles";
import styles from "./styles/form.css.js";
import { SourceUseSelect, SourceBrandSelect, SourceTypeSelect } from "components/select";
import { RestrictedToAdmin } from "components/auth";
import { PartnerSelect } from "components/select";

import {
    SOURCE_FUNCTION_TYPE_ACTIVATE,
    SOURCE_FUNCTION_TYPE_DEACTIVATE,
    SOURCE_ICON_TYPE_CHECK,
    SOURCE_ICON_TYPE_CLOSE
} from "../../../../utils/constants";

const isScoreboardSourceType = type => type === "scoreboard";

const CAMERA = 'camera';




const NewSourceForm = ({ intl, values, handleChange, onSelectValidationSchema, classes }) => {
  useEffect(
    () => {
      onSelectValidationSchema(values.type);
    },
    [onSelectValidationSchema, values.type],
  );


  return (
    <>
      <DataGrid>
        <DataGridItem>
          <SourceTypeSelect
            isInsideForm
            label={intl.formatMessage({ id: "source.type" })}
            onChange={name => value => {
              if (isScoreboardSourceType(value)) {
                handleChange("brand")("Other");
                handleChange("model")("");
                handleChange("use")("fixed");
              }

              handleChange("scoreboardPerspective")("");
              handleChange(name)(value);
            }}
            value={values.type}
          />
        </DataGridItem>
        <DataGridItem />
        <DataGridItem>
          <SourceUseSelect
            disabled={isScoreboardSourceType(values.type)}
            isInsideForm
            label={intl.formatMessage({ id: "source.use" })}
            onChange={handleChange}
            value={values.use}
          />
        </DataGridItem>
        <DataGridItem>
          {values.use === "scoreboard" && values.type === "camera" && (
            <FormTextField
              type="text"
              id="scoreboardPerspective"
              name="scoreboardPerspective"
              value={values.scoreboardPerspective}
              onChange={handleChange}
              label={intl.formatMessage({ id: "source.scoreboardPerspective" })}
            />
          )}
        </DataGridItem>
      </DataGrid>
      <DataGridItem>
        <FormTextField
          type="text"
          id="serial"
          name="serial"
          value={values.serial}
          onChange={handleChange}
          label={intl.formatMessage({ id: "source.serial" })}
        />
      </DataGridItem>
      <DataGridItem>
        <SourceBrandSelect
          disabled={isScoreboardSourceType(values.type)}
          isInsideForm
          label={intl.formatMessage({ id: "source.brand" })}
          onChange={handleChange}
          value={values.brand}
        />
      </DataGridItem>
      {!isScoreboardSourceType(values.type) && (
        <DataGridItem>
          <FormTextField
            type="text"
            id="model"
            name="model"
            value={values.model}
            onChange={handleChange}
            label={intl.formatMessage({ id: "source.model" })}
          />
        </DataGridItem>
      )}
      <DataGridItem>
        <FormTextField
          type="text"
          id="owner"
          name="owner"
          value={values.owner}
          onChange={handleChange}
          label={intl.formatMessage({ id: "source.owner" })}
        />
      </DataGridItem>
      <DataGridItem>
        <FormTextField
          type="text"
          id="description"
          name="description"
          value={values.description}
          onChange={handleChange}
          label={intl.formatMessage({ id: "common.description" })}
        />
      </DataGridItem>
      <DataGridItem>
        <FormTextField
          type="text"
          id="deploymentNeeds"
          name="deploymentNeeds"
          value={values.deploymentNeeds}
          onChange={handleChange}
          label={intl.formatMessage({ id: "source.deploymentNeeds" })}
        />
      </DataGridItem>
      <DataGridItem>
        {!isScoreboardSourceType(values.type) && (
          <FormTextField
            type="text"
            id="currentFirmware"
            name="currentFirmware"
            value={values.currentFirmware}
            onChange={handleChange}
            label={intl.formatMessage({ id: "source.currentFirmware" })}
          />
        )}
      </DataGridItem>
      <DataGridItem>
      <FormCheckbox
        id="usuallyDisconnected"
        name="usuallyDisconnected"
        value="usuallyDisconnected"
        checked={values.usuallyDisconnected}
        onChange={handleChange}
        label={intl.formatMessage({ id: "deployment.usuallyDisconnected" })}
      />
    </DataGridItem>
      {values.publicInterface && (
        <Card className={classes.card} title={<FormattedMessage id="app.page.source.publicInterface" />}>
          <DataGrid>
            <DataGridItem>
              <FormTextField
                type="number"
                id="publicInterface.adminTcpPort"
                name="publicInterface.adminTcpPort"
                value={values.publicInterface.adminTcpPort}
                onChange={handleChange}
                label={intl.formatMessage({ id: "source.interface.adminTcpPort" })}
              />
            </DataGridItem>
            {!isScoreboardSourceType(values.type) && (
              <>
                <DataGridItem>
                  <FormTextField
                    type="number"
                    id="publicInterface.adminSslPort"
                    name="publicInterface.adminSslPort"
                    value={values.publicInterface.adminSslPort}
                    onChange={handleChange}
                    label={intl.formatMessage({ id: "source.interface.adminSslPort" })}
                  />
                </DataGridItem>
                <DataGridItem>
                  <FormCheckbox
                    id="publicInterface.adminTls"
                    name="publicInterface.adminTls"
                    value="publicInterface.adminTls"
                    checked={values.publicInterface.adminTls}
                    onChange={handleChange}
                    label={intl.formatMessage({ id: "source.interface.adminTls" })}
                  />
                </DataGridItem>
              </>
            )}
            <DataGridItem>
              <FormTextField
                type="text"
                id="publicInterface.ip"
                name="publicInterface.ip"
                value={values.publicInterface.ip}
                onChange={handleChange}
                label={intl.formatMessage({ id: "source.interface.ip" })}
              />
            </DataGridItem>
            <RestrictedToAdmin>
              {!isScoreboardSourceType(values.type) && (
                <>
                  <DataGridItem>
                    <FormTextField
                      type="text"
                      id="publicInterface.streamTcpUrl"
                      name="publicInterface.streamTcpUrl"
                      value={values.publicInterface.streamTcpUrl}
                      onChange={handleChange}
                      label={intl.formatMessage({ id: "source.interface.streamTcpUrl" })}
                    />
                  </DataGridItem>
                  <DataGridItem>
                    <FormTextField
                      type="text"
                      id="publicInterface.adminUrl"
                      name="publicInterface.adminUrl"
                      value={values.publicInterface.adminUrl}
                      onChange={handleChange}
                      label={intl.formatMessage({ id: "source.interface.adminUrl" })}
                    />
                  </DataGridItem>
                </>
              )}
            </RestrictedToAdmin>
            <DataGridItem>
              <FormTextField
                type="number"
                id="publicInterface.videoStreamPort"
                name="publicInterface.videoStreamPort"
                value={values.publicInterface.videoStreamPort}
                onChange={handleChange}
                label={intl.formatMessage({ id: "source.interface.videoStreamPort" })}
              />
            </DataGridItem>
            <DataGridItem>
            <FormTextField
              type="text"
              id="publicInterface.ptzControllerPort"
              name="publicInterface.ptzControllerPort"
              value={Number(values.publicInterface.ptzControllerPort)}
              onChange={handleChange}
              label={intl.formatMessage({ id: "source.ptzControllerPort" })}
            />
            </DataGridItem>
            {!isScoreboardSourceType(values.type) && (
              <DataGridItem>
                <FormTextField
                  type="text"
                  id="publicInterface.protocol"
                  name="publicInterface.protocol"
                  value={values.publicInterface.protocol}
                  onChange={handleChange}
                  label={intl.formatMessage({ id: "source.interface.protocol" })}
                />
              </DataGridItem>
            )}
            {values.type === CAMERA && (
              <>
                  <DataGridItem>
                    <FormTextField
                      type="text"
                      id="publicInterface.secondCoachUrl"
                      name="publicInterface.secondCoachUrl"
                      value={values.publicInterface.secondCoachUrl}
                      onChange={handleChange}
                      label={intl.formatMessage({ id: "source.interface.secondCoach.URL" })}
                    />
                  </DataGridItem>
              </>
                )}
          </DataGrid>
        </Card>
      )}
      {isScoreboardSourceType(values.type) && values.privateInterface && (
        <Card className={classes.card} title={<FormattedMessage id="app.page.source.privateInterface" />}>
          <DataGrid>
            <DataGridItem>
              <FormTextField
                type="number"
                id="privateInterface.adminTcpPort"
                name="privateInterface.adminTcpPort"
                value={values.privateInterface.adminTcpPort}
                onChange={handleChange}
                label={intl.formatMessage({ id: "source.privateInterface.adminTcpPort" })}
              />
            </DataGridItem>
            <DataGridItem>
              <FormTextField
                type="text"
                id="privateInterface.ip"
                name="privateInterface.ip"
                value={values.privateInterface.ip}
                onChange={handleChange}
                label={intl.formatMessage({ id: "source.privateInterface.ip" })}
              />
            </DataGridItem>
            <DataGridItem>
              <FormTextField
                type="number"
                id="privateInterface.videoStreamTcpPort"
                name="privateInterface.videoStreamTcpPort"
                value={values.privateInterface.videoStreamTcpPort}
                onChange={handleChange}
                label={intl.formatMessage({ id: "source.privateInterface.videoStreamTcpPort" })}
              />
            </DataGridItem>
          </DataGrid>
        </Card>
      )}
      {values.users && (
        <>
          {values.users.admin && (
            <Card className={classes.card}>
              <DataGrid>
                <DataGridItem>
                  <FormTextField
                    type="text"
                    id="users.admin.user"
                    name="users.admin.user"
                    value={values.users.admin.user}
                    onChange={handleChange}
                    label={intl.formatMessage({ id: "source.admin" })}
                  />
                </DataGridItem>
                <DataGridItem>
                  <FormTextField
                    type="text"
                    id="users.admin.pass"
                    name="users.admin.pass"
                    value={values.users.admin.pass}
                    onChange={handleChange}
                    label={intl.formatMessage({ id: "source.admin.pass" })}
                  />
                </DataGridItem>
              </DataGrid>
            </Card>
          )}
          {!isScoreboardSourceType(values.type) && values.users.viewer && (
            <Card className={classes.card}>
              <DataGrid>
                <DataGridItem>
                  <FormTextField
                    type="text"
                    id="users.viewer.user"
                    name="users.viewer.user"
                    value={values.users.viewer.user}
                    onChange={handleChange}
                    label={intl.formatMessage({ id: "source.viewer" })}
                  />
                </DataGridItem>
                <DataGridItem>
                  <FormTextField
                    type="text"
                    id="users.viewer.pass"
                    name="users.viewer.pass"
                    value={values.users.viewer.pass}
                    onChange={handleChange}
                    label={intl.formatMessage({ id: "source.viewer.pass" })}
                  />
                </DataGridItem>
              </DataGrid>
            </Card>
          )}
        </>
      )}
      <RestrictedToAdmin excludePartners>
        <Card className={classes.card}>
          <DataGrid>
            <DataGridItem>
              <Typography variant="h6">
                <FormattedMessage id="app.page.user.associateToPartner" />
              </Typography>
              <PartnerSelect
                isInsideForm
                label={intl.formatMessage({ id: "app.partner" })}
                onChange={name => value => handleChange(name)(value)}
                value={values.ownedByPartnerId}
              />
            </DataGridItem>
          </DataGrid>
        </Card>
      </RestrictedToAdmin>
    </>
  );
};

NewSourceForm.propTypes = {
  /**
   * Valores del formulario
   */
  values: PropTypes.object,
  /**
   * Callback que se dispara con el cambio del input
   */
  handleChange: PropTypes.func,
  /**
   * Callback que se dispara cuando se cambia el tipo de source para
   * seleccionar el esquema de validación a aplicar
   */
  onSelectValidationSchema: PropTypes.func.isRequired,
};

export default withStyles(styles)(injectIntl(NewSourceForm));
